import React from 'react'

const Info = () => {
    return(
        <div className="about__info grid">
            <div className="about__box">
                <i className="bx bx-award about__icon"></i>
                <h3 className="about__title">Experience</h3>
                <span className="about__subtitle">3 Years</span>
            </div>

            <div className="about__box">
                <i className="bx bx-store about__icon"></i>
                <h3 className="about__title">Building</h3>
                <span className="about__subtitle">Berryfy</span>
            </div>

            <div className="about__box">
                <i className="bx bx-bot about__icon"></i>
                <h3 className="about__title">Focus</h3>
                <span className="about__subtitle">Automation</span>
            </div>
        </div>
    )
}

export default Info;
